<template>
  <div class="fixed z-10 inset-0 overflow-y-auto disconnected" aria-modal="true">
    <div class="flex loading-container mt-10">
      <Loading :text="$t('app.reconnecting')" />
    </div>
  </div>
</template>
<script>
import Loading from './LoadingWidget.vue'

export default {
  name: 'DisconnectedModal',
  components: {
    Loading,
  }
}
</script>
